// PsyPractice / hukuki belgeler / Українська.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar; aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir;
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Фізична особа-підприємець";

const OWNER = 'PsyPractice (далі «Платформа» або «Контролер даних»)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Умови використання та відмова від відповідальності",
    description:
      "Характер і межі послуги, що вона не замінює, зобов’язання користувача та повна відмова від відповідальності, яка покладає всю відповідальність на користувача.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Сторони та прийняття",
        paras: [
          `Ці Умови використання укладаються між ${OWNER} та будь-якою фізичною або юридичною особою, яка отримує доступ до Платформи або користується нею («Користувач»). Створюючи обліковий запис, входячи в систему або будь-яким чином користуючись Платформою, Користувач підтверджує, що прочитав, зрозумів і беззастережно приймає ці Умови в повному обсязі та зобов’язується їх дотримуватися. Той, хто не приймає ці Умови, не повинен користуватися Платформою.`,
        ],
      },
      {
        heading: "2. Характер і межі послуги",
        bullets: [
          "PsyPractice є програмним забезпеченням для СИМУЛЯЦІЇ пацієнтів за допомогою ШІ, яке дає студентам-психологам і клініцистам-початківцям змогу здійснювати й фіксувати власну практику проведення бесід у безпечному середовищі.",
          "PsyPractice не є освітньою чи навчальною послугою; це програмний інструмент, який дає користувачеві змогу здійснювати й фіксувати власну практику. Платформа не надає уроків, навчальних програм, іспитів чи документів і не присвоює жодного звання, кваліфікації чи повноважень.",
          "Симульований «пацієнт» не є реальним клієнтом; його відповіді синтезуються штучним інтелектом, можуть бути помилковими, неповними, суперечливими або оманливими та не претендують на клінічну точність чи істинність.",
        ],
      },
      {
        heading: "2.1. Що Платформа не замінює",
        bullets: [
          "Це НЕ реальна терапія чи консультування, і вона не замінює жодного сеансу, проведеного з реальним клієнтом.",
          "Це НЕ замінник клінічної супервізії. Звіти зі зворотним зв’язком, які створює ШІ-супервізор, є автоматично згенерованим текстом; вони не є експертним висновком, офіційною оцінкою чи балом.",
          "Це НЕ інструмент діагностики, скринінгу чи оцінювання; жоден результат роботи Платформи не може використовуватися для діагностики чи ухвалення клінічних рішень щодо будь-якої реальної особи.",
          "Її НЕ МОЖНА використовувати в кризових чи надзвичайних ситуаціях. У разі суїцидальних думок, ризику заподіяння шкоди собі чи іншим або будь-якої подібної надзвичайної ситуації закрийте Платформу й негайно зверніться до місцевих служб екстреної допомоги або компетентного закладу охорони здоров’я.",
          "Це НЕ джерело професійної компетентності, ліцензії, звання чи повноважень; час, проведений на Платформі, та її результати не можуть бути подані жодній установі як підтвердження кваліфікації.",
        ],
      },
      {
        heading: "3. Заяви та зобов’язання Користувача",
        bullets: [
          "Користувач зобов’язується користуватися Платформою виключно в законних та етичних межах, з метою розвитку власної професійної практики.",
          "Користувач погоджується НЕ вводити жодних РЕАЛЬНИХ даних пацієнтів/клієнтів, ідентифікаційної інформації чи даних особливої категорії про стан здоров’я будь-якої особи; усі правові наслідки таких дій лягають виключно на Користувача.",
          "Користувач зобов’язується не використовувати жодних результатів, отриманих на Платформі, для діагностики, лікування, втручання чи ухвалення клінічних рішень щодо будь-якої реальної особи.",
          "Користувач самостійно відповідає за власну професійну компетентність, обсяг повноважень і дотримання чинних професійних та етичних норм.",
          "Безпека облікового запису, конфіденційність пароля та вся діяльність, здійснювана під обліковим записом Користувача, є відповідальністю Користувача.",
          "Обліковий запис є особистим; Користувач зобов’язується не передавати його іншим особам і не використовувати Платформу за допомогою автоматизованих засобів (боти, скрипти тощо). Використання платних планів підпадає під обмеження чесного використання (наразі 60 сесій на календарний місяць), докладно описане в Договорі дистанційного продажу.",
        ],
      },
      {
        heading: "4. Уся відповідальність лежить на Користувачеві (відмова від претензій)",
        paras: [
          "Платформа надається «ЯК Є» та «ЯК ДОСТУПНО», без будь-яких явних чи неявних гарантій (зокрема щодо безперебійної роботи, відсутності помилок, придатності для певної мети, точності чи актуальності).",
          "Користувач приймає та зобов’язується, що він ВИКЛЮЧНО й ОСОБИСТО відповідає за будь-які прямі, непрямі, випадкові, особливі чи наслідкові збитки (зокрема матеріальні, моральні, збитки для професійної репутації, втрату даних, втрату доходу та шкоду, заподіяну третім особам), що виникають унаслідок користування Платформою чи неможливості нею користуватися, покладання на результати ШІ чи будь-якого застосування таких результатів.",
          "У максимальному обсязі, дозволеному чинним законодавством, Користувач цим безвідклично й беззастережно ВІДМОВЛЯЄТЬСЯ, зараз і наперед, від будь-яких претензій, позовів і прав на відшкодування, які він міг би висунути проти Платформи, її власників, працівників, розробників, ділових партнерів і постачальників послуг у зв’язку з будь-якою шкодою, якої він може зазнати в разі будь-якого несприятливого результату.",
          "Користувач також зобов’язується повністю убезпечити Платформу (відшкодувати їй збитки) від будь-яких претензій, збитків, штрафів і витрат (зокрема витрат на адвокатів), якщо до Платформи звернеться будь-яка третя особа чи установа через власну вину, недбалість Користувача або користування з порушенням цих Умов.",
        ],
      },
      {
        heading: "5. Обмеження відповідальності",
        paras: [
          "Без шкоди для імперативних норм чинного законодавства загальна юридична відповідальність Платформи в будь-якому разі обмежується сумою, фактично сплаченою Користувачем Платформі за 12 місяців, що передували події, яка стала підставою для відповідної претензії. У разі безкоштовного користування ця сума дорівнює нулю.",
        ],
      },
      {
        heading: "6. Інтелектуальна власність, зміни та припинення",
        bullets: [
          "Усі права інтелектуальної власності на Платформу, її програмне забезпечення, дизайн, шаблони випадків пацієнтів і зміст належать Платформі.",
          "Усі майнові права інтелектуальної власності, що можуть передаватися, на будь-який зміст, який Користувач створює на Платформі (зокрема написані ним повідомлення терапевта, транскрипти сеансів і похідні від них матеріали), вважаються переданими Платформі виключно, безстроково та без виплати винагороди в момент створення такого змісту; Платформа може використовувати, відтворювати та обробляти цей зміст у всьому світі й без обмежень з будь-якою метою, зокрема для роботи сервісу, створення зворотного зв’язку та вдосконалення й розвитку системи (зокрема вдосконалення за допомогою машинного навчання). Права Користувача щодо персональних даних за чинним законодавством про захист даних (GDPR / KVKK) цією передачею не зачіпаються та залишаються за ним.",
          "Платформа залишає за собою право будь-коли змінювати, призупиняти чи припиняти дію цих Умов і обсяг послуги без попереднього повідомлення.",
          "У разі порушення цих Умов Платформа може призупинити або закрити обліковий запис без попереднього повідомлення.",
        ],
      },
      {
        heading: "7. Застосовне право та юрисдикція",
        paras: [
          "Ці Умови регулюються законодавством Турецької Республіки. Суди та виконавчі органи Турецької Республіки мають юрисдикцію щодо будь-якого спору, який може виникнути.",
          "Для споживачів, які проживають у Європейському Союзі, зберігається захист, передбачений імперативними нормами законодавства про захист прав споживачів країни їхнього проживання та їхніми правами щодо захисту даних за GDPR; цей вибір права не скасовує таких імперативних норм.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Політика конфіденційності",
    description:
      "GDPR як базовий стандарт; оброблювані дані, правові підстави, хостинг у ЄС, міжнародні передачі (постачальник ШІ) та положення ст. 9 KVKK про транскордонну передачу для користувачів у Туреччині.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Ця Політика конфіденційності пояснює, як обробляються персональні дані в межах Платформи, якою керує ${OWNER}. Як базовий стандарт захисту даних політика дотримується Загального регламенту ЄС про захист даних (GDPR / 2016/679); для користувачів, які перебувають у Туреччині, додатково застосовується турецький Закон про захист персональних даних № 6698 (KVKK), зокрема стаття 9 про передачу за кордон. Повідомлення KVKK та Заява про явну згоду є невід’ємними частинами цієї політики.`,
        ],
      },
      {
        heading: "Контролер даних і місце хостингу",
        bullets: [
          "Контролер даних: PsyPractice. Запити суб’єктів даних опрацьовуються через контактний канал, оголошений на Платформі (контактна електронна адреса: info@psycora.com).",
          "Хостинг: Платформа та її база даних розміщені в Європейському Союзі, у центрі обробки даних у Нідерландах (Oracle Cloud). Для користувачів, які перебувають у ЄС/ЄЕЗ, дані обробляються та зберігаються в межах ЄС.",
          "Постачальник хостингу діє виключно як обробник на підставі укладеної Угоди про обробку даних (DPA).",
        ],
      },
      {
        heading: "Дані, що збираються",
        bullets: [
          "Дані облікового запису: ім’я, електронна адреса, хешований пароль, відомості про підписку/план.",
          "Дані про користування: створені сеанси, транскрипти сеансів, згенеровані випадки пацієнтів, звіти супервізора зі зворотним зв’язком.",
          "Технічні дані: записи сесій, IP-адреса, браузер/мовні налаштування, журнали обмеження частоти запитів і безпеки.",
        ],
      },
      {
        heading: "Цілі обробки та правова підстава (ст. 6 GDPR)",
        bullets: [
          "Виконання договору (ст. 6(1)(b)): створення облікового запису, проведення сеансів, пам’ять пацієнта між сеансами, оцінювання супервізором, керування підпискою та лімітами користування.",
          "Законний інтерес (ст. 6(1)(f)): безпека, запобігання зловживанням, удосконалення системи та усунення несправностей.",
          "Юридичний обов’язок (ст. 6(1)(c)): зберігання/звітування, передбачені законодавством.",
          "Згода (ст. 6(1)(a)): обробка для аналітики/вдосконалення продукту, яка не є строго необхідною для надання послуги, і, де це потрібно, передача за межі ЄС/ЄЕЗ.",
        ],
      },
      {
        heading: "Міжнародні передачі",
        paras: [
          "Оскільки хостинг здійснюється в ЄС (Нідерланди), дані користувачів з ЄС/ЄЕЗ за загальним правилом обробляються в межах ЄС без передачі до третьої країни на цьому рівні. Однак для створення відповідей ШІ зміст сеансів і запити передаються постачальнику послуг ШІ (Anthropic), чия інфраструктура обробки може розташовуватися за межами ЄС/ЄЕЗ (наприклад, у Сполучених Штатах).",
          "Такі передачі за межі ЄС/ЄЕЗ ґрунтуються на належних гарантіях відповідно до ст. 44 і наступних GDPR, зокрема на Стандартних договірних положеннях (SCC) Європейської Комісії, і з постачальником укладається угода про обробку даних (DPA). Платформа НЕ продає персональні дані з маркетинговою метою; дані не передаються третім особам, крім випадків, коли це строго необхідно для роботи сервісу (із застереженням щодо законних запитів компетентних органів).",
        ],
      },
      {
        heading: "Для користувачів у Туреччині: ст. 9 KVKK (передача за кордон)",
        paras: [
          "Персональні дані користувачів, які перебувають у Туреччині, передаються за межі Туреччини, оскільки хостинг розміщено в Нідерландах (ЄС), а також можуть передаватися компанії Anthropic для обробки ШІ. Ці передачі підпадають під ст. 9 KVKK і ґрунтуються на належних гарантіях (стандартний договір / зобов’язання, опубліковані Радою) або, де це потрібно, на Вашій явній згоді. Обсяг, отримувачі та мета передачі докладно описані в Повідомленні KVKK та Заяві про явну згоду.",
        ],
      },
      {
        heading: "Права суб’єктів даних (ст. 15-22 GDPR)",
        bullets: [
          "Доступ, виправлення, видалення («право бути забутим») та обмеження обробки.",
          "Перенесення даних: отримання наданих Вами даних у структурованому, загальновживаному, машинозчитуваному форматі.",
          "Заперечення: заперечення проти обробки на підставі законного інтересу та проти прямого маркетингу.",
          "Права, пов’язані з ухваленням рішень щодо особи виключно на основі автоматизованої обробки/профілювання.",
          "Відкликання згоди будь-коли для обробки, що ґрунтується на згоді (відкликання не впливає на законність обробки до цього моменту).",
          "Право подати скаргу до наглядового органу: відповідний орган захисту даних у ЄС; Управління із захисту персональних даних (KVKK) у Туреччині.",
        ],
      },
      {
        heading: "Зберігання та безпека",
        bullets: [
          "Дані зберігаються стільки, скільки цього вимагає мета обробки, і протягом строків, встановлених чинним законодавством; після закінчення строку вони видаляються або анонімізуються.",
          "Чутливі поля (наприклад, пароль, коди підтвердження та скидання) зберігаються в зашифрованому/хешованому вигляді; доступ надається на основі дозволів.",
          "Оскільки жоден метод передачі чи зберігання не є безпечним на 100%, абсолютну безпеку гарантувати неможливо.",
        ],
      },
      {
        heading: "Заборона на реальні дані пацієнтів",
        paras: [
          "Платформа є симуляційним програмним забезпеченням; введення персональних даних/даних про стан здоров’я реальних клієнтів заборонено. Уся відповідальність, що виникає внаслідок введення Користувачем даних з порушенням цієї заборони, лягає виключно на Користувача.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "Повідомлення KVKK",
    description:
      "Контролер даних, цілі обробки, правова підстава, передача та права суб’єктів даних відповідно до статті 10 Закону № 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Контролер даних",
        paras: [
          `Відповідно до статті 10 турецького Закону про захист персональних даних № 6698 («KVKK») Ваші персональні дані обробляються ${OWNER} як Контролером даних в обсязі, описаному нижче.`,
        ],
      },
      {
        heading: "Оброблювані дані та цілі",
        bullets: [
          "Ідентифікаційні/контактні (ім’я, електронна адреса): створення облікового запису, автентифікація, комунікація.",
          "Клієнтські операції (підписка, план, користування): надання послуги, виставлення рахунків, застосування лімітів.",
          "Безпека операцій (сесія, IP-адреса, журнали): безпека, запобігання зловживанням, юридичний обов’язок.",
          "Зміст користувача (транскрипти сеансів, згенеровані випадки): надання програмної послуги та створення зворотного зв’язку.",
          "Членство в інституційній когорті (ідентифікатор когорти, період членства): якщо користувач приєднується до когорти, яку веде установа, видимість для куратора та адміністрування когорти.",
        ],
      },
      {
        heading: "Правова підстава (ст. 5)",
        bullets: [
          "Укладення/виконання договору: дані, необхідні для надання послуги.",
          "Законний інтерес контролера даних: безпека, запобігання шахрайству, вдосконалення системи.",
          "Юридичний обов’язок: зберігання/звітування, передбачені законодавством.",
          "Явна згода: передача за кордон (ст. 9) та додаткова обробка, яка не є строго необхідною для надання послуги.",
        ],
      },
      {
        heading: "Передача за кордон (ст. 9)",
        paras: [
          "Оскільки Платформа та її база даних розміщені в Європейському Союзі, у центрі обробки даних у Нідерландах (Oracle Cloud), персональні дані користувачів, які перебувають у Туреччині, передаються за межі Туреччини (до ЄС). Крім того, для створення відповідей ШІ зміст сеансів і запити можуть передаватися постачальнику послуг ШІ (Anthropic), чия інфраструктура обробки може розташовуватися за межами ЄС/ЄЕЗ (наприклад, у Сполучених Штатах).",
          "Ці передачі за кордон підпадають під ст. 9 KVKK і ґрунтуються на належних гарантіях, таких як стандартний договір / зобов’язання, опубліковані Радою, або, де це потрібно, на Вашій явній згоді. З постачальниками хостингу та послуг укладаються угоди про обробку даних (DPA).",
        ],
      },
      {
        heading: "Інституційні когорти та видимість для куратора",
        paras: [
          "Якщо Ви приєднуєтеся до когорти, відкритої університетом, клінікою чи подібною установою, зміст Ваших сеансів (транскрипти) та звіти супервізора може бачити куратор цієї когорти протягом усього періоду її тривання. Ця видимість охоплює лише Ваші сеанси, прив’язані до когорти, і припиняється із завершенням Вашого членства в когорті.",
          "Цей доступ отримується через ОКРЕМИЙ екран явної згоди, який показується під час приєднання до когорти; він не є частиною загального прийняття умов Платформи. Якщо Ви не даєте цієї згоди, Ви не можете приєднатися до когорти, але можете й далі користуватися Платформою індивідуально, як і раніше. Відкликання згоди припиняє Ваше членство в когорті й не впливає на Ваше індивідуальне користування.",
        ],
      },
      {
        heading: "Права суб’єктів даних (ст. 11)",
        bullets: [
          "Дізнатися, чи обробляються Ваші персональні дані, і, якщо так, вимагати інформацію про це.",
          "Дізнатися мету обробки та чи використовуються дані відповідно до цієї мети.",
          "Знати третіх осіб, яким дані передаються всередині країни чи за кордон.",
          "Вимагати виправлення неповної/неправильної обробки та, за наявності умов, видалення/знищення даних.",
          "Заперечувати проти результату, що виникає на шкоду Вам виключно внаслідок автоматизованого аналізу.",
          "Вимагати відшкодування шкоди, заподіяної внаслідок незаконної обробки.",
        ],
      },
      {
        heading: "Звернення",
        paras: [
          "Ви можете подавати запити щодо своїх прав через контактний канал, оголошений Контролером даних. Звернення розглядаються у строки, встановлені KVKK та підзаконними актами до нього.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Заява про явну згоду",
    description:
      "Окремо від повідомлення про обробку даних; добровільно надана згода на передачу за кордон та обробку за допомогою ШІ.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Я заявляю, що прочитав(-ла) і зрозумів(-ла) Повідомлення KVKK, і що я добровільно, усвідомлено та явно даю згоду на описану нижче обробку. (Відповідно до рішення Ради KVKK № 2018/90 явна згода отримується окремо від обов’язку інформування.)",
        ],
      },
      {
        heading: "Обробка, на яку надається згода",
        bullets: [
          "Передача моїх персональних даних за межі Туреччини, їх зберігання та обробка там, оскільки Платформа розміщена в Європейському Союзі (Нідерланди / Oracle Cloud) (ст. 9 KVKK).",
          "Передача та обробка транскриптів моїх сеансів і запитів у постачальника послуг ШІ (Anthropic), чия інфраструктура обробки може розташовуватися за межами ЄС/ЄЕЗ, з метою створення відповідей ШІ (ст. 9 KVKK).",
          "Обробка для вдосконалення продукту та аналітики, яка не є строго необхідною для надання послуги.",
          "Отримання сповіщень, пов’язаних із послугою.",
        ],
      },
      {
        heading: "Відкликання згоди",
        paras: [
          "Я розумію, що можу будь-коли відкликати свою явну згоду; однак, оскільки передача за кордон постачальнику ШІ технічно необхідна для роботи послуги, я приймаю, що відкликання цієї згоди може призвести до неможливості користуватися відповідними функціями або послугою загалом. Відкликання не впливає на законність обробки, здійсненої до дати відкликання.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice; see the comment there.
    id: "outreach",
    title: "Повідомлення щодо інформаційних розсилок",
    description:
      "Для науковців і представників установ, які отримали корпоративний інформаційний лист: звідки взято дані, чому вони обробляються, правова підстава та як відмовитися.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Це повідомлення інформує отримувачів корпоративних інформаційних листів, які PsyPractice надсилає кафедрам психології університетів та їхнім науково-педагогічним працівникам, відповідно до статті 10 турецького Закону про захист персональних даних № 6698 (KVKK) та Комюніке про порядок і принципи виконання обов’язку інформування. Оскільки Ваші персональні дані отримано не безпосередньо від Вас, інформування здійснюється щонайпізніше в момент першого контакту, тому інформаційний лист містить посилання сюди.",
        ],
      },
      {
        heading: "1. Контролер даних",
        bullets: [
          `Найменування: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Адреса: ${MERCHANT.addressEn}`,
          `Податкова інспекція / номер: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Електронна пошта: ${MERCHANT.email}`,
          `Вебсайт: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Оброблювані дані та їх джерело",
        paras: [
          "Обробка обмежується професійними контактними даними: ім’я, науковий ступінь/звання, університет і кафедра, інституційна електронна адреса та, якщо опубліковано, інституційний номер телефону.",
          "Ці дані не збиралися від Вас, а були зібрані з публічно опублікованих офіційних сторінок кафедр і факультетів університетів. Особливі категорії даних не обробляються, а приватні (неінституційні) електронні адреси для розсилок не використовуються.",
        ],
      },
      {
        heading: "3. Мета",
        paras: [
          "Ваші дані обробляються, щоб представити програмний інструмент, створений для підготовки психологів, запросити Вашу кафедру до можливої розмови про пілотний проєкт чи співпрацю та вести пов’язане з цим листування. Вони не використовуються з жодною іншою метою, не продаються й не передаються третім особам для маркетингу.",
        ],
      },
      {
        heading: "4. Правова підстава",
        paras: [
          "Обробка ґрунтується на законних інтересах контролера даних відповідно до статті 5/2-(f) KVKK, за умови, що це не завдає шкоди Вашим основним правам і свободам: контакт здійснюється лише на інституційну адресу, лише з питання, безпосередньо пов’язаного з професійною сферою отримувача, та обмежену кількість разів.",
          "Сам факт публічної доступності даних в інтернеті не є правовою підставою. Рада із захисту персональних даних постановила, що публічність даних не робить їх придатними для будь-якої мети і що намір та мету оприлюднення слід оцінювати окремо; тому стаття 5/2-(d) не застосовується.",
        ],
      },
      {
        heading: "5. Передачі та зберігання",
        paras: [
          "Листування ведеться через постачальника електронної пошти, чия інфраструктура може розташовуватися за кордоном; такі передачі здійснюються з належними гарантіями відповідно до статті 9 KVKK.",
          "Ваші дані видаляються після досягнення мети контакту або на Ваш запит. Після запиту на видалення зберігається лише строго обмежений запис «не контактувати», виключно для того, щоб з Вами більше не зв’язувалися; він ніколи не використовується для розсилок.",
        ],
      },
      {
        heading: "6. Комерційні електронні повідомлення та право на відмову",
        paras: [
          "Рекламні повідомлення підпадають під дію Закону № 6563 про регулювання електронної комерції. Ви можете відмовитися від їх отримання без пояснення причин; відмови опрацьовуються щонайпізніше протягом трьох робочих днів, після чого жодних подальших рекламних повідомлень не надсилається. Достатньо відповісти на отриманий лист або написати на " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Ваші права",
        paras: [
          "Відповідно до статті 11 KVKK Ви маєте право дізнатися, чи обробляються Ваші персональні дані, вимагати інформацію про це, дізнатися мету обробки та чи використовуються дані відповідно до неї, знати третіх осіб, яким вони передаються в Туреччині чи за кордоном, вимагати виправлення неповних чи неточних даних, вимагати їх видалення чи знищення, вимагати повідомлення про ці дії третім особам, заперечувати проти результату на шкоду Вам, отриманого виключно внаслідок автоматизованого аналізу, та вимагати відшкодування заподіяної шкоди.",
          `Запити можна надсилати на ${MERCHANT.email}; відповідь надається щонайпізніше протягом тридцяти днів. За Вами також зберігається право подати скаргу до Ради із захисту персональних даних.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Політика щодо файлів cookie",
    description: "Типи використовуваних файлів cookie, їх цілі та керування налаштуваннями.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Платформа використовує файли cookie та подібні технології локального зберігання (localStorage), щоб підтримувати Вашу сесію та запам’ятовувати Ваші налаштування.",
        ],
      },
      {
        heading: "Використовувані технології",
        bullets: [
          "Строго необхідні: токен сесії/автентифікації, безпека. Без них сервіс не працює.",
          "Функціональні: мовні налаштування (NEXT_LOCALE), налаштування інтерфейсу (наприклад, тема).",
          "Продуктивність/безпека: технічні журнали для обмеження частоти запитів і виявлення зловживань.",
        ],
      },
      {
        heading: "Керування налаштуваннями",
        paras: [
          "Ви можете видалити або заблокувати файли cookie у своєму браузері; однак блокування строго необхідних файлів cookie унеможливить вхід і основні функції. Відповідно до принципів GDPR / ePrivacy та Посібника KVKK щодо файлів cookie необов’язкові файли cookie використовуються лише на підставі Вашого явного вибору/згоди.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Про нас",
    description:
      "Мета PsyPractice, послуга, яку вона пропонує, та контактні дані продавця.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice є платформою симуляції пацієнтів за допомогою ШІ та розвитку клінічних навичок, створеною для студентів-психологів і нещодавніх випускників, клініцистів-початківців. Користувачі проводять текстові терапевтичні сеанси; наприкінці кожного сеансу ШІ-супервізор оцінює розмову й створює звіт зі зворотним зв’язком для розвитку. ШІ-пацієнт переносить терапевтичні стосунки від сеансу до сеансу завдяки пам’яті між сеансами.",
        ],
      },
      {
        heading: "Наша місія",
        paras: [
          "Наша мета полягає в тому, щоб дати майбутнім фахівцям із психічного здоров’я безпечне, повторюване середовище, у якому можна практикувати навички проведення бесід без жодного ризику зашкодити реальним клієнтам. PsyPractice не є освітньою чи навчальною послугою; це програмний інструмент, який дає користувачеві змогу здійснювати й фіксувати власну практику. Це не реальна терапія чи консультування, не замінник клінічної супервізії, не інструмент діагностики чи оцінювання, і її не можна використовувати в кризових чи надзвичайних ситуаціях.",
        ],
      },
      {
        heading: "Що ми пропонуємо",
        bullets: [
          "Симуляція текстових терапевтичних сеансів з різноманітними профілями пацієнтів, синтезованими з клінічної літератури.",
          "Автоматизовані звіти з оцінкою супервізора після кожного сеансу.",
          "Модель «живого пацієнта» з пам’яттю між сеансами, яка з часом розвиває терапевтичні стосунки.",
          "Створення власних пацієнтів, що дає студентам змогу створювати власні ШІ-випадки.",
          "Метрики прогресу, які відстежують розвиток мікронавичок.",
        ],
      },
      {
        heading: "Інформація про продавця / підприємця",
        bullets: [
          `Комерційне найменування: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Адреса: ${MERCHANT.addressEn}`,
          `Податкова інспекція / номер: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Електронна пошта: ${MERCHANT.email}`,
          `Вебсайт: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Договір дистанційного продажу",
    description:
      "Продавець, покупець, послуга, ціна, оплата, виконання та умови права на відмову відповідно до турецького Закону № 6502 та Положення про дистанційні договори.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Сторони",
        bullets: [
          `ПРОДАВЕЦЬ: ${MERCHANT.legalName} (${OWNER_TYPE}). Адреса: ${MERCHANT.addressEn}. Податкова інспекція/номер: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. Електронна пошта: ${MERCHANT.email}.`,
          "ПОКУПЕЦЬ: фізична або юридична особа, яка створює обліковий запис на Платформі та купує платну підписку («Покупець»).",
        ],
      },
      {
        heading: "2. Предмет Договору",
        paras: [
          "Предметом цього Договору є визначення прав та обов’язків сторін відповідно до турецького Закону № 6502 про захист прав споживачів та Положення про дистанційні договори щодо продажу та надання підписки на цифрову послугу, придбаної Покупцем електронним шляхом через Платформу, характеристики та ціна продажу якої зазначені нижче.",
        ],
      },
      {
        heading: "3. Характер послуги та ціна",
        bullets: [
          "Продавана послуга є функціями симуляції пацієнтів за допомогою ШІ, які пропонуються в межах платного плану підписки на програмне забезпечення PsyPractice (цифрова послуга / право користування програмним забезпеченням).",
          "PsyPractice не є освітньою чи навчальною послугою; це програмний інструмент, який дає користувачеві змогу здійснювати й фіксувати власну практику. Плата за підписку є платою за доступ до цього програмного забезпечення; це не плата за уроки, навчальні програми, іспити, консультації чи будь-який документ.",
          "Зміст плану, строк (місячний, 4-місячний період або річний) і чинна ціна чітко відображаються на сторінці цін/оплати Платформи в момент купівлі; загальна сума з урахуванням податків повідомляється Покупцеві до оплати.",
          "Ціни застосовуються у валюті, показаній на Платформі; якщо підписку не скасовано, вона автоматично поновлюється за тією самою ціною після закінчення обраного строку.",
          "У планах, що пропонуються як «необмежені сесії», використання підпадає під обмеження чесного використання (наразі 60 сесій на календарний місяць). Після досягнення обмеження нові сесії можна знову розпочинати з першого дня наступного календарного місяця; це не дає права на зниження ціни чи повернення коштів. Обмеження запобігає спільному використанню облікових записів і автоматизованому використанню, і Продавець не змінює його на шкоду Покупцеві протягом оплаченого періоду підписки.",
        ],
      },
      {
        heading: "4. Оплата",
        paras: [
          "Платежі приймаються безпечно кредитною/дебетовою карткою через ліцензовану платіжну установу iyzico. Дані картки Продавцем не зберігаються; платіж обробляється через захищені системи iyzico. Для періодичних платежів (підписки) сума автоматично списується з картки, схваленої Покупцем, у кожному періоді поновлення.",
        ],
      },
      {
        heading: "5. Виконання та надання",
        paras: [
          "Послуга є цифровою й не передбачає фізичної доставки. Після підтвердження оплати функції підписки негайно стають доступними в обліковому записі Покупця. Виконання здійснюється електронним шляхом через надання безперервного доступу протягом усього строку підписки.",
        ],
      },
      {
        heading: "6. Право на відмову та виняток з нього",
        bullets: [
          "Відповідно до статті 15/1-(ğ) Положення про дистанційні договори право на відмову не може бути реалізоване щодо нематеріальних (цифрових) товарів/послуг, які надаються миттєво в електронній формі, якщо надання розпочалося за згодою Покупця.",
          "Покупець у момент купівлі визнає, що послуга буде надана негайно і що, відповідно, право на відмову не виникає. Покупець може будь-коли скасувати підписку, щоб зупинити поновлення; скасування набирає чинності наприкінці поточного оплаченого періоду.",
          "Докладні умови повернення коштів див. у «Умовах надання та повернення».",
        ],
      },
      {
        heading: "7. Спори та набрання чинності",
        paras: [
          "У разі спору Покупець може звернутися до Арбітражного комітету у справах споживачів або до Судів у справах споживачів за місцем свого проживання в межах грошових лімітів, оголошених Міністерством торгівлі. Цей Договір укладається та набирає чинності з моменту схвалення Покупцем в електронній формі.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Умови надання та повернення",
    description:
      "Надання цифрової послуги, скасування підписки, виняток з права на відмову та умови повернення коштів.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Надання (цифрова послуга)",
        bullets: [
          "PsyPractice є повністю цифровою послугою; фізичного відправлення товару чи кур’єрської доставки немає.",
          "У момент підтвердження оплати функції підписки активуються автоматично й миттєво в обліковому записі Покупця; окремого строку чи плати за доставку немає.",
          "Доступ до послуги здійснюється через веббраузер будь-якого пристрою, підключеного до інтернету.",
        ],
      },
      {
        heading: "Скасування підписки",
        bullets: [
          "Покупець може будь-коли скасувати підписку в налаштуваннях облікового запису. Скасування набирає чинності наприкінці поточного оплаченого періоду й зупиняє наступне автоматичне поновлення.",
          "Після скасування доступ до послуги зберігається до кінця оплаченого періоду.",
        ],
      },
      {
        heading: "Право на відмову та повернення коштів",
        bullets: [
          "Оскільки послуга є цифровою послугою, що надається негайно за згодою Покупця, за загальним правилом право на відмову, а отже й право на повернення коштів, не виникає відповідно до статті 15/1-(ğ) Положення про дистанційні договори.",
          "У випадках явного недоліку, таких як помилкове/подвійне списання, повна неможливість доступу до послуги з технічних причин або подібне, Покупець може запросити повернення коштів, звернувшись до Продавця протягом розумного строку з дати оплати.",
          `Запити на повернення коштів надсилаються на ${MERCHANT.email}; схвалені повернення здійснюються на картку, якою було сплачено, через інфраструктуру iyzico, за загальним правилом протягом 14 днів. Строк повернення може відрізнятися залежно від часу обробки банком.`,
        ],
      },
      {
        heading: "Контакти",
        paras: [
          `З усіх питань надання, скасування та повернення коштів: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
